module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Marketing Number setup","completeButton":"Continue building automation","automationFooter":"Can I use my Keap Business Line for automations?"}}')
  delete Component.options._Ctor
}
